import React, { useEffect } from "react";
import Topbar from "../../components/layouts/Topbar";
import Footer from "../../components/layouts/Footer";
import METVAppBody from "../../pages";

const FreeTestLayout: React.FC = () => {
  useEffect(() => {
    setMetvBodyHeight();
    window.addEventListener("resize", setMetvBodyHeight);
    return () => {
      window.removeEventListener("resize", setMetvBodyHeight);
    };
  }, []);

  const setMetvBodyHeight = () => {
    let headerH = document.getElementById("metv-header")?.clientHeight || 0;
    let footerH = document.getElementById("metv-footer")?.clientHeight || 0;
    let mainLayoutH = document.getElementById("main-layout")?.clientHeight || 0;
    let metvBody = document.getElementById("metv-body");
    if (metvBody) {
      metvBody.style.height = mainLayoutH - headerH - footerH + "px";
    }
  };

  return (
    <div className="w-full h-full" id="main-layout">
      <div className="w-full" id="metv-header">
        <Topbar />
      </div>
      <div className={`w-full overflow-y-auto py-2`} id="metv-body">
        <METVAppBody />
        <div className="md:hidden">
          <Footer />
        </div>
      </div>
      <div
        className="absolute bottom-0 w-full hidden md:block"
        id="metv-footer"
      >
        <Footer />
      </div>
    </div>
  );
};

export default FreeTestLayout;
